export default "__VITE_ASSET__kzBbIbi7__"